import { render } from "./Chargecalculator.vue?vue&type=template&id=2da8832c"
import script from "./Chargecalculator.vue?vue&type=script&lang=js"
export * from "./Chargecalculator.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__